import React, { useEffect } from "react";
import Slider from "react-slick";
import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import tilteImg1 from "./../../assets/images/login/TitleImg1.svg";
import tilteImg2 from "./../../assets/images/login/TitleImg2.svg";
import tilteImg3 from "./../../assets/images/login/TitleImg3.svg";
import banner1 from "./../../assets/images/login/bannerImg1.svg";
import banner2 from "./../../assets/images/login/bannerImg2.svg";
import banner3 from "./../../assets/images/login/bannerImg3.svg";
import useMediaQuery from "../common/custom-hooks/use-media-query";
const CarouselContainer = styled.div`
  width: 40%;
  margin: 0 auto;
`;

const Slide = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(180deg, #3b82f6, #9333ea);
  color: white;
  font-size: 24px;
  font-weight: bold;
`;

const CustomDot = styled.div`
  width: ${(props) => (props.active ? "30px" : "30px")};
  height: 4px;
  border-radius: ${(props) => (props.active ? "5px" : "5px")};
  background: ${(props) => (props.active ? "#5405BD" : "#F7F7F7")};
  margin: 0 5px;
  transition: all 0.3s ease-in-out;
  cursor: pointer; /* Make the indicators clickable */
`;

const Banner = () => {
  const sliderRef = React.useRef(null); // Reference to the slider
  const [currentSlide, setCurrentSlide] = React.useState(0);
  const isMxDesktop = useMediaQuery("(min-width: 2560px)");
  const isSmMxDesktop = useMediaQuery("(min-width: 1905px)");
  const isLapi = useMediaQuery("(min-width: 1536px)");
 const isLapiHeight = useMediaQuery("(min-height: 793px)");
  

  useEffect(() => {
    // console.log('testing isMxDesktop', isMxDesktop);
    // console.log('testing isSmMxDesktop', isSmMxDesktop);
    // console.log('testing isLapi', isLapi)
    //  console.log('testing isLapiHeight', isLapiHeight);
  }, [isMxDesktop,isSmMxDesktop,isLapi,isLapiHeight])
  
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    beforeChange: (_, next) => setCurrentSlide(next),
    appendDots: (dots) => (
      <div
        style={{
          display: "none", // Hide the default outer dots
        }}
      >
        {dots}
      </div>
    ),
  };

  const slides = [
    {
      img: banner1,
      icon: tilteImg1,
      headingText: "Advancing Health Through Innovation",
      dec: "Driving breakthroughs in healthcare to improve lives through innovative research",
    },
    {
      img: banner2,
      icon: tilteImg2,
      headingText: "Seamless Conversations, Anytime",
      dec: "Effortless communication and support, just a message away",
    },
    {
      img: banner3,
      icon: tilteImg3,
      headingText: "Seamless Conversations, Anytime",
      dec: "Effortless communication and support, just a message away",
    },
  ];
  useEffect(() => {
    console.log("sliderRef", sliderRef);
  }, [sliderRef]);
  return (
    <CarouselContainer>
      <Slider {...settings} ref={sliderRef}>
        {slides.map((slide, index) => (
          <Slide key={index}>
            <div
              style={{
                backgroundImage: `url(${slide.img})`,
                width: "100%",
                height: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div className=" bg-transparent rounded-lg flex justify-center  min-w-[525px] min-h-[584px] w-full h-full relative">
                <div className="mr-4"></div>
                <div className="absolute top-[65vh]">
                  <h2 className="font-mont font-[600] text-[30px] text-[#1B2A3D] mb-5 mx-auto text-center">
                    {slide.headingText}
                  </h2>
                  <p className="font-mont font-[500] text-[16px] text-[#373737] text-center">
                    {slide.dec}
                  </p>
                </div>

                <div
                  style={{
                    position: "absolute",
                    top: "80vh",
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                    //   justifyContent: "center",
                      padding: "10px",
                    //   marginTop: "-50px",
                    }}
                  >
                    {slides.map((_, dotIndex) => (
                      <CustomDot
                        key={dotIndex}
                        active={dotIndex === currentSlide}
                        onClick={() => sliderRef.current.slickGoTo(dotIndex)} // Navigate to slide
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </Slide>
        ))}
      </Slider>
    </CarouselContainer>
  );
};

export default Banner;
